
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">

            <div class="container" *ngIf="personnages">
              <div class="row">
                <div class="col">Joueur</div>
                <div class="col">Personnage</div>
                <div class="col">Nb. GN</div>
                <div class="col">Crimson</div>
                <div class="col-3">Avoirs</div>
                <div class="col">Coup de grâce</div>
                <div class="col-3">Notes</div>
                <div class="col">Action</div>
              </div>
              <form (ngSubmit)="onSubmit(personnage.id, crimsonDisponible.value, avoirs.value, coupDeGrace.value, notes.value)" *ngFor="let personnage of personnages" class="input-group row">
                <div class="col">{{personnage.joueur}}</div>
                <div class="col">{{ personnage.nom }}</div>
                <div class="col">{{ personnage.nombreGnParticipe }}</div>
                <div class="col"><input #crimsonDisponible class="form-control" type="text" value="{{personnage.crimsonDisponible}}"></div>
                <div class="col-3"><input #avoirs class="form-control" type="text"></div>
                <div class="col"><input #coupDeGrace class="form-control" type="text"></div>
                <div class="col-3"><input #notes class="form-control" type="text"></div>
                <div class="col input-group-append">
                  <input class="btn" type="submit" value="Désinscrire">
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>